<template>
  <div class="loading">
    <div class="spinner">
      <div class="lds-bar modal-dialog">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999;
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: -25px;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}
.lds-bar {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-bar div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #29343f;
  animation: lds-bar 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-bar div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.lds-bar div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.lds-bar div:nth-child(3) {
  left: 56px;
  animation-delay: 0;
}
@keyframes lds-bar {
  0% {
    top: 8px;
    height: 64px;
  }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
}
</style>
